/* Koji · card prodotto condivisa
   Carrello (aggiungi, quantità) e cuore dei preferiti.
   Listener delegati: funzionano anche sulle card caricate dopo (consigliati, pagine collezione, ricerca). */
(function () {
  'use strict';
  if (window.__kojiProductCard) return;
  window.__kojiProductCard = true;

  var WISHLIST_KEY = 'koji_wishlist_data';
  var CARD = '.kcard[data-kcard]';

  /* ---------- utilità ---------- */
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function vibrate(p) { try { if (navigator.vibrate) navigator.vibrate(p); } catch (e) {} }
  function readWishlist() {
    try { var l = JSON.parse(localStorage.getItem(WISHLIST_KEY)); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }

  /* ---------- preferiti: stessa logica del resto del tema, definita solo se manca ---------- */
  window.toggleProductWishlistItem = window.toggleProductWishlistItem || function (handle, title, price, image, btn) {
    var list = readWishlist();
    var i = -1;
    for (var k = 0; k < list.length; k++) { if (list[k].handle === handle) { i = k; break; } }
    if (i > -1) {
      list.splice(i, 1);
      btn.classList.remove('is-active');
    } else {
      list.push({ handle: handle, title: title, price: price, image: image });
      btn.classList.add('is-active');
      vibrate(50);
    }
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
    var badges = document.querySelectorAll('.koji-wishlist-badge');
    for (var b = 0; b < badges.length; b++) {
      badges[b].textContent = list.length;
      badges[b].classList.toggle('is-active', list.length > 0);
    }
  };

  function syncHearts() {
    var list = readWishlist();
    all('.kcard .koji-card-wishlist-btn').forEach(function (btn) {
      var h = btn.getAttribute('data-handle');
      var on = list.some(function (x) { return x.handle === h; });
      btn.classList.toggle('is-active', on);
    });
  }

  /* ---------- stato del carrello ---------- */
  var cartQty = {};     // id variante -> quantità nel carrello
  var pending = {};     // id variante -> quantità richiesta ma non ancora confermata
  var timers = {};
  var cartLoaded = false;
  var cartLoading = false;
  var refreshTimer = null;

  function parse(r) {
    return r.json().then(function (j) {
      if (!r.ok) {
        var e = new Error(j && (j.description || j.message) || 'Errore');
        e.api = true;
        throw e;
      }
      return j;
    });
  }
  function errText(err, fallback) { return err && err.api && err.message ? err.message : fallback; }
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(parse);
  }
  function readCart(cart) {
    cartQty = {};
    (cart.items || []).forEach(function (it) { cartQty[String(it.variant_id)] = it.quantity; });
    cartLoaded = true;
  }
  function qtyFor(vid) { return pending[vid] != null ? pending[vid] : (cartQty[vid] || 0); }

  function setBadge(count) {
    var b = document.getElementById('koji-cart-badge');
    if (b) { b.textContent = count; b.classList.toggle('is-active', count > 0); }
  }
  function broadcast(cart) {
    setBadge(cart.item_count || 0);
    try { window.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'kcard' } })); }
    catch (e) { window.dispatchEvent(new Event('cart:updated')); }
  }

  function paintCard(card) {
    var add = card.querySelector('[data-kcard-add]');
    var stepper = card.querySelector('.kcard__stepper');
    if (!add || !stepper) return;
    var vid = card.getAttribute('data-variant');
    var q = qtyFor(vid);
    var max = parseInt(card.getAttribute('data-max'), 10) || 0;
    add.hidden = q > 0;
    stepper.hidden = !(q > 0);
    var out = stepper.querySelector('[data-kcard-qty]');
    if (out) out.textContent = q;
    var plus = stepper.querySelector('[data-kcard-step="1"]');
    if (plus) plus.disabled = !!max && q >= max;
  }
  function paintAll() { all(CARD).forEach(paintCard); }

  function refreshCart() {
    if (cartLoading) return;
    cartLoading = true;
    fetchCart()
      .then(function (cart) { readCart(cart); paintAll(); setBadge(cart.item_count || 0); })
      .catch(function () {})
      .then(function () { cartLoading = false; });
  }

  /* ---------- messaggi (annunciati dagli screen reader, visibili solo se errore) ---------- */
  function say(card, msg, isError) {
    var el = card.querySelector('[data-kcard-status]');
    if (!el) return;
    clearTimeout(el.__s);
    clearTimeout(el.__t);
    el.classList.toggle('is-error', !!isError);
    el.textContent = '';
    el.__s = setTimeout(function () { el.textContent = msg; }, 50);
    if (isError) {
      el.__t = setTimeout(function () { el.textContent = ''; el.classList.remove('is-error'); }, 6000);
    }
  }
  function nameOf(card) {
    var l = card.querySelector('.kcard__link');
    return l ? l.textContent.trim() : 'Il prodotto';
  }
  function focusStepper(card) {
    var plus = card.querySelector('[data-kcard-step="1"]');
    var minus = card.querySelector('[data-kcard-step="-1"]');
    var target = plus && !plus.disabled ? plus : minus;
    if (target) target.focus({ preventScroll: true });
  }

  /* ---------- aggiungi ---------- */
  function add(card, btn) {
    var vid = card.getAttribute('data-variant');
    var label = btn.querySelector('span');
    var original = label ? label.textContent : '';
    btn.disabled = true;
    btn.classList.add('is-busy');
    if (label) label.textContent = 'Aggiungo…';
    vibrate(30);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    })
      .then(parse)
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        readCart(cart);
        paintAll();
        broadcast(cart);
        say(card, nameOf(card) + ' aggiunto al carrello. Quantità: ' + qtyFor(vid) + '.', false);
        focusStepper(card);
      })
      .catch(function (err) {
        say(card, errText(err, 'Non siamo riusciti ad aggiungerlo. Riprova tra un attimo.'), true);
        refreshCart();
      })
      .then(function () {
        btn.disabled = false;
        btn.classList.remove('is-busy');
        if (label) label.textContent = original;
      });
  }

  /* ---------- quantità ---------- */
  function step(card, delta) {
    var vid = card.getAttribute('data-variant');
    var cur = qtyFor(vid);
    var max = parseInt(card.getAttribute('data-max'), 10) || 0;
    var next = cur + delta;
    if (next < 0) return;
    if (max && next > max) { say(card, 'Ne abbiamo solo ' + max + ' disponibili.', true); return; }
    vibrate(15);
    pending[vid] = next;
    paintAll();
    if (next === 0) {
      var addBtn = card.querySelector('[data-kcard-add]');
      if (addBtn) addBtn.focus({ preventScroll: true });
    }
    clearTimeout(timers[vid]);
    timers[vid] = setTimeout(function () { commit(vid, card); }, 400);
  }

  function commit(vid, card) {
    var sent = pending[vid];
    if (sent == null) return;
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(vid), quantity: sent })
    })
      .then(parse)
      .then(function (cart) {
        if (pending[vid] === sent) delete pending[vid];
        readCart(cart);
        paintAll();
        broadcast(cart);
        say(card, sent === 0 ? nameOf(card) + ' rimosso dal carrello.' : 'Quantità nel carrello: ' + sent + '.', false);
      })
      .catch(function (err) {
        if (pending[vid] === sent) delete pending[vid];
        paintAll();
        say(card, errText(err, 'Non siamo riusciti ad aggiornare il carrello.'), true);
        refreshCart();
      });
  }

  /* ---------- click delegati ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var addBtn = t.closest('[data-kcard-add]');
    if (addBtn) {
      var c1 = addBtn.closest(CARD);
      if (c1) { e.preventDefault(); add(c1, addBtn); }
      return;
    }
    var stepBtn = t.closest('[data-kcard-step]');
    if (stepBtn) {
      var c2 = stepBtn.closest(CARD);
      if (c2) {
        e.preventDefault();
        step(c2, parseInt(stepBtn.getAttribute('data-kcard-step'), 10) || 0);
      }
    }
  });

  /* ---------- card caricate dopo (consigliati, altre pagine della collezione, ricerca) ---------- */
  var scheduled = false;
  function afterInsert() {
    scheduled = false;
    syncHearts();
    if (cartLoaded) paintAll(); else refreshCart();
  }
  function onDomChange(muts) {
    if (scheduled) return;
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && ((n.classList && n.classList.contains('kcard')) || (n.querySelector && n.querySelector('.kcard')))) {
          scheduled = true;
          window.requestAnimationFrame(afterInsert);
          return;
        }
      }
    }
  }

  window.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.source === 'kcard') return;
    if (!document.querySelector(CARD)) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCart, 150);
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && document.querySelector(CARD)) { syncHearts(); refreshCart(); }
  });

  function start() {
    if (document.querySelector(CARD)) { syncHearts(); refreshCart(); }
    if (window.MutationObserver && document.body) {
      new MutationObserver(onDomChange).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
